import { SERVICES } from "@/data/services";
import { PSYCHOLOGISTS } from "@/data/psychologists";
import { PROGRAMS } from "@/data/programs";
import { TOPIC_PAGES } from "@/data/topics";
import { ANSWERS } from "@/data/answers";

const STATIC_MAP = [
  ["layanan", "services"],
  ["psikolog", "psychologists"],
  ["asesmen-psikologi", "psychological-assessment"],
  ["program", "programs"],
  ["kesehatan-mental", "mental-health"],
  ["jawaban", "answers"],
  ["faq", "faq"],
  ["lokasi", "location"],
  ["kontak", "contact"],
  ["buat-janji", "book"],
  ["kebijakan-privasi", "privacy-policy"],
  ["syarat-ketentuan", "terms"],
  ["kebijakan-pembatalan", "cancellation-policy"],
  ["psikolog-denpasar", "psychologist-denpasar"],
  ["psikolog-renon", "psychologist-renon"],
  ["psikolog-sanur", "psychologist-sanur"],
];

const slugPairs = [
  ...SERVICES.map((s) => [s.slug.id, s.slug.en]),
  ...PROGRAMS.map((p) => [p.slug.id, p.slug.en]),
  ...Object.values(TOPIC_PAGES).map((t) => [t.slug.id, t.slug.en]),
  ...ANSWERS.map((a) => [a.slug.id, a.slug.en]),
  ...PSYCHOLOGISTS.map((p) => [p.slug, p.slug]),
];

const mapSeg = (seg, toEn) => {
  for (const [idSeg, enSeg] of [...STATIC_MAP, ...slugPairs]) {
    if (toEn && seg === idSeg) return enSeg;
    if (!toEn && seg === enSeg) return idSeg;
  }
  return seg;
};

export const getLang = (pathname) =>
  pathname === "/en" || pathname.startsWith("/en/") ? "en" : "id";

export const translatePath = (pathname) => {
  const lang = getLang(pathname);
  if (lang === "id") {
    const segs = pathname.split("/").filter(Boolean).map((s) => mapSeg(s, true));
    return "/en" + (segs.length ? "/" + segs.join("/") : "");
  }
  const segs = pathname.split("/").filter(Boolean).slice(1).map((s) => mapSeg(s, false));
  return segs.length ? "/" + segs.join("/") : "/";
};
